import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormEditSummaryItem } from './FormEditSummaryItem';
import { useAttachmentsComponent } from '../../hooks/useAttachmentsComponent';
import { CustomAttachmentField } from '../../../../../components/incidentForm/fields/customAttachment/customAttachmentField';

export const EditSummaryAttachmentItem = ({ field, onFinish, parents }) => {
  const [fieldData, setFieldData] = useState(field);
  const { uploadAttachment } = useAttachmentsComponent({
    idInput: field.idInput,
    parents,
  });

  const onChange = (value) => {
    setFieldData((current) => ({
      ...current,
      value,
    }));
  };

  return (
    <FormEditSummaryItem showActionsInTitle fullWidthInput onFinish={onFinish} field={fieldData}>
      <CustomAttachmentField field={fieldData} onChange={onChange} uploadFile={(_, file) => uploadAttachment(file)} />
    </FormEditSummaryItem>
  );
};

EditSummaryAttachmentItem.propTypes = {
  field: PropTypes.object,
  onFinish: PropTypes.func,
  parents: PropTypes.arrayOf(PropTypes.string),
};
